/**
 * 挂载全局
 * @type {{exportExcel(*, *, *=): void}}
 */
const Excel = {
    exportExcel(columns, list, sheet) {
        require.ensure([], () => {
            const {export_json_to_excel} = require('../excel/Export2Excel');
            let tHeader = [];
            let filterVal = [];
            columns.forEach(item => {
                tHeader.push(item.title);
                filterVal.push(item.key)
            });
            const data = list.map(v => filterVal.map(j => v[j]));
            export_json_to_excel(tHeader, data, sheet);
        })
    }
};
export {Excel}
